import Vue from "vue";
import $ from "jquery";
import { Component } from "vue-property-decorator";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { ParametresInstance } from "../Controls/Parameters";
import { ParametreModuleDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreModuleDto";
import ModalUpdate from "./modalUpdate/modalUpdate";

@Component({
	components: {
		ModalUpdate: require("./modalUpdate/modalUpdate.vue.html")
	},
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as ParametrageModuleComponent);
			vm.Init();
		});
	},
	beforeRouteUpdate(to, from, next) {
		next(v => {
			const vm = v as ParametrageModuleComponent;
			vm.Init();
		});
	}

})
export default class ParametrageModuleComponent extends Vue {
	public modalUpdate?: ModalUpdate = undefined;
	public currentOrderColumn = "StrLabel";
	public orderingDesc = true;

	public filterName = "";
	public filterModule = "PST";
	public modules: string[] = [];
	public parametragesModule: ParametreModuleDto[] = [];
	public parametragesModuleFiltered: ParametreModuleDto[] = [];
	public dataReady = false;

	public Init(): void {
    	if (ParametresInstance.societeCourante == undefined) {
			return;
		}

    	ServicesFactoryInstance.ParametragesModuleService.getModules(data => {
    		this.modules = data;
    		ServicesFactoryInstance.ParametragesModuleService.getParametragesModule(data => {
    			this.parametragesModule = data;
    			this.parametragesModuleFiltered = this.parametragesModule;
    			this.getClassOfOrder(this.currentOrderColumn, true);
    			this.doFilter();
    			this.dataReady = true;
    		});
    	});
	}

	public update(id: number): void {
    	if (this.modalUpdate == undefined) {
			this.modalUpdate = this.$refs.modalUpdate as ModalUpdate;
		}

    	if (this.modalUpdate != undefined) {
			this.modalUpdate.Init(id);
		}

    	$("#modalUpdate").modal("show");
	}

	public maskedValue(item: ParametreModuleDto): string {
    	return item.IsSensitive ? "•••••••••" : (item.StrData || "");
	}

	public getClassOfOrder(columnName: string, desc: boolean): string {
    	if (columnName == this.currentOrderColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	public orderBy(columnName: string): void {
    	if (this.currentOrderColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.currentOrderColumn = columnName;
    	this.doOrder();
	}

	public doOrder(): void {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.currentOrderColumn;
    	if (this.parametragesModuleFiltered != undefined) {
    		this.parametragesModuleFiltered.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	public doFilter(): void {
    	if (this.filterName == undefined || this.filterName == "") {
			this.parametragesModuleFiltered = this.parametragesModule.filter(s => this.filterModule == s.StrModule);
		} else {
			this.parametragesModuleFiltered = this.parametragesModule.filter(s =>
    			(s.Id != undefined && s.Id.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.StrModule != undefined && s.StrModule.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.StrId != undefined && s.StrId.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.StrData != undefined && s.StrData.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0) ||
                (s.StrLabel != undefined && s.StrLabel.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0));
		}
    	this.doOrder();
	}
}



// WEBPACK FOOTER //
// ./src/components/parametrageModule/parametrageModule.ts